import {updateDates} from '../../../../commons/actions/dates'
import {PLACE_ORDER_OLD, UPDATE_ORDER_OLD, getOrder, placeOrder, updateOrder} from '../actions/placed-order'

export const datesMiddleware = store => next => action => {
  switch (action.type) {
    case PLACE_ORDER_OLD.SUCCESS:
    case placeOrder.fulfilled.toString():
    case UPDATE_ORDER_OLD.SUCCESS:
    case updateOrder.fulfilled.toString():
    case getOrder.fulfilled.toString(): {
      store.dispatch(updateDates(action.payload.dates))
      break
    }
    default:
      break
  }
  next(action)
}
